import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { scBrandName } from '@/pages/pageListAll/pageOneSc/config';

export default [
  {
    path: '/IFPageOneHSixtyThreePreLogin',
    name: 'IFPageOneHSixtyThreePreLogin',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtyThreeLogin' ||
        from.path === '/IFPageOneHSixtyThreeLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtyThreeLogin',
    name: 'pageOneHSixtyThreeLogin',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyThreeLoginLoading',
    name: 'pageOneHSixtyThreeLoginLoading',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyThreeLeaveInfo',
    name: 'pageOneHSixtyThreeLeaveInfo',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyThreeResult',
    name: 'pageOneHSixtyThreeResult',
    meta: {
      title: scBrandName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyThreeLoading',
    name: 'pageOneHSixtyThreeLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/loading.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneHSixtyThreeLoginSecond',
    name: 'pageOneHSixtyThreeLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/loginSecond.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneHSixtyThreeOnline',
    name: 'pageOneHSixtyThreeOnline',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/online.vue'),
    meta: {
      title: scBrandName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHSixtyThreeLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHSixtyThreeGuide',
    name: 'pageOneHSixtyThreeLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/guide.vue'),
    meta: {
      title: scBrandName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHSixtyThreeCar',
    name: 'pageOneHSixtyThreeCar',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHSixtyThreeCarDetails',
    name: 'pageOneHSixtyThreeCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHSixtyThreeBlank',
    name: 'pageOneHSixtyThreeBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/blank.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneHSixtyThreeOnlineTab',
    name: 'pageOneHSixtyThreeOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/onlineTab.vue'),
    meta: {
      title: scBrandName,
    },
  },
  {
    path: '/IFPageOneHSixtyThreeOnlineAd',
    name: 'pageOneHSixtyThreeOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHSixtyThree/onlineAd.vue'),
    meta: {
      title: scBrandName,
    },
  },
];
